import React from 'react';
import avatarIcon from '../../../../../../shared/assets/images/lotto-assistant/avatar.svg';
import classes from './AssistantAvatar.module.scss';

const SIZES = {
  small: 20,
  medium: 32,
  large: 40,
};

const AssistantAvatar = ({ size = 'medium', customClass }) => {
  const px = SIZES[size] ?? SIZES.medium;
  return (
    <span
      className={classes.Avatar + (customClass ? ' ' + customClass : '')}
      style={{ width: px, height: px }}
    >
      <img src={avatarIcon} alt="" width={px} height={px} />
    </span>
  );
};

export default React.memo(AssistantAvatar);
